module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 12 7",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }